/**
 * Trims surrounding whitespace from an email string.
 *
 * Returns an empty string for non-string inputs so downstream `.trim()`
 * calls cannot throw when a wallet SDK returns an unexpected shape.
 *
 * PAY-6701: EPS profile validation rejects emails with leading/trailing
 * whitespace, blocking guest BI-account creation for wallet checkouts.
 *
 * @param {*} value - Value to normalize; only strings are trimmed
 * @returns {string} Trimmed string, or '' when input is not a string
 */
const normalizeEmail = value => (typeof value === 'string' ? value.trim() : '');

export { normalizeEmail };
